module.exports = __webpack_public_path__ + "media/assets/images/rw-modal-03-9a0e98af016495990ad801d40d37b0e0.jpg";